import { VALIDATION } from '../constants/template-builder';
import type { SkeletonTemplateEdgeT, SkeletonTemplateNodeT } from '../types/annotations.type';
type ValidationResult = {
  message: string;
} | null;
export function validateSkeletonTemplate(nodes: ReadonlyArray<SkeletonTemplateNodeT>, edges: ReadonlyArray<SkeletonTemplateEdgeT>, aspectRatio: number): ValidationResult {
  if (nodes.length < 2) return {
    message: VALIDATION.MIN_NODES
  };
  if (edges.length < 1) return {
    message: VALIDATION.MIN_EDGES
  };
  if (aspectRatio <= 0) return {
    message: VALIDATION.INVALID_ASPECT_RATIO
  };
  const nodeIds = new Set<string>();
  const nodeLabels = new Set<string>();
  for (const [index, node] of nodes.entries()) {
    if (!node.id.trim()) return {
      message: VALIDATION.NODE_BLANK_ID(index)
    };
    if (!node.label.trim()) return {
      message: VALIDATION.NODE_BLANK_LABEL(index)
    };
    if (nodeIds.has(node.id)) return {
      message: VALIDATION.NODE_DUPLICATE_ID(node.id)
    };
    nodeIds.add(node.id);
    if (nodeLabels.has(node.label)) return {
      message: VALIDATION.NODE_DUPLICATE_LABEL(node.label)
    };
    nodeLabels.add(node.label);
    if (node.x < 0 || node.x > 1 || node.y < 0 || node.y > 1) {
      return {
        message: VALIDATION.NODE_POSITION_OUT_OF_RANGE(node.label || `Node ${index + 1}`)
      };
    }
  }
  const edgeKeys = new Set<string>();
  for (const edge of edges) {
    if (!edge.sourceNodeId.trim() || !edge.targetNodeId.trim()) {
      return {
        message: VALIDATION.EDGE_BLANK_NODES
      };
    }
    if (edge.sourceNodeId === edge.targetNodeId) {
      return {
        message: VALIDATION.EDGE_SELF_REFERENCE(edge.sourceNodeId)
      };
    }
    if (!nodeIds.has(edge.sourceNodeId)) {
      return {
        message: VALIDATION.EDGE_INVALID_NODE(edge.sourceNodeId)
      };
    }
    if (!nodeIds.has(edge.targetNodeId)) {
      return {
        message: VALIDATION.EDGE_INVALID_NODE(edge.targetNodeId)
      };
    }
    const key = `${edge.sourceNodeId}->${edge.targetNodeId}`;
    if (edgeKeys.has(key)) {
      return {
        message: VALIDATION.EDGE_DUPLICATE(edge.sourceNodeId, edge.targetNodeId)
      };
    }
    edgeKeys.add(key);
  }
  return null;
}